import crel from 'crel'

const hndlr = promise => promise
    .then(data => ([data,]))
    .catch(error => ([, error]))

const resolver = p => new Promise((resolve, reject) => {
    p.then(result => resolve({result}))
    p.catch(error => resolve({error}))
})


const Q = document.querySelector.bind(document)

const QA = document.querySelectorAll.bind(document)

const toggleClass = function (item, classes) {
    if (!Array.isArray(classes)) classes = [classes]
    classes.forEach(klass => item.classList.contains(klass) ? item.classList.remove(klass) : item.classList.add(klass))
}

function sequentialLoad(urls, callback) {
    const elements = urls.map(url => crel('script', {src: url}))
    for (const [i, v] of elements.entries()) {
        if (i < elements.length - 1) elements[i].onload = () => crel(document.body, elements[i + 1])
    }
    if (callback) elements[elements.length - 1].onload = callback
    crel(document.body, elements[0])
}

function jsonFromTag(id) {
    try {
        return JSON.parse(document.getElementById(id).textContent)
    } catch (err) {
        //console.log(err)
        return null
    }
}

function wait(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

function sniffPublication(title) {
    if(title.toLowerCase().includes('delo')) return 'Delo'
    if(title.toLowerCase().includes('slovenske')) return 'Slovenske novice'
    if(title.toLowerCase().includes('onaplus')) return 'OnaPlus'
    if(title.toLowerCase().includes('in dom')) return 'Delo in dom'
    return 'Drugo'
}

export {
    hndlr,
    QA,
    Q,
    toggleClass,
    sequentialLoad,
    jsonFromTag,
    resolver,
    wait,
    sniffPublication
}
